import { render, staticRenderFns } from "./OriginalDocumentsTable.vue?vue&type=template&id=69dad230"
import script from "./OriginalDocumentsTable.vue?vue&type=script&lang=js"
export * from "./OriginalDocumentsTable.vue?vue&type=script&lang=js"
import style0 from "./OriginalDocumentsTable.vue?vue&type=style&index=0&id=69dad230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports